import { NotifyProps, notify } from 'components/Shared/NotifyLink';
import { ButtonProps, LoadingButtonProps, Button } from './button';

interface NotifyButtonProps extends Pick<NotifyProps, 'ticket'>, ButtonProps {}

export const NotifyButton = ({ onClick, children, ticket, ...props }: NotifyButtonProps) => {
  return (
    <Button onClick={notify(ticket, onClick)} {...props}>
      {children}
    </Button>
  );
};

interface NotifyLoadingButtonProps extends Pick<NotifyProps, 'ticket'>, LoadingButtonProps {}

export const NotifyLoaderButton = ({
  onClick,
  children,
  ticket,
  ...props
}: NotifyLoadingButtonProps) => {
  return (
    <Button onClick={notify(ticket, onClick)} {...props}>
      {children}
    </Button>
  );
};
